import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-slate-900 group-[.toaster]:border-slate-200 group-[.toaster]:shadow-xl",
          description: "group-[.toast]:text-slate-600",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success: "group-[.toaster]:border-emerald-300 group-[.toaster]:bg-emerald-50 group-[.toaster]:text-emerald-900 [&>[data-description]]:!text-emerald-700",
          error: "group-[.toaster]:border-red-300 group-[.toaster]:bg-red-50 group-[.toaster]:text-red-900 [&>[data-description]]:!text-red-700",
          info: "group-[.toaster]:border-blue-300 group-[.toaster]:bg-blue-50 group-[.toaster]:text-blue-900 [&>[data-description]]:!text-blue-700",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
